/**
 * Horizontal mirror of shared millimetre geometry around the overall vertical centre.
 * Layout bounds stay unflipped; only the painted assembly is transformed.
 */
export function horizontalMirrorTransform(overallWidthMm: number): string {
  return `translate(${overallWidthMm} 0) scale(-1 1)`;
}
